export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14066.519350a1.jpg";